import React from 'react';
import { useOutletContext } from 'react-router-dom';
import AssistantList from './AssistantList';

const AssistantPage = () => {
    const { handleCreateNew, handleEdit, handleSelectAssistant, refreshAssistants } = useOutletContext();
  return (
    <AssistantList 
      key={refreshAssistants}
      onCreateNew={handleCreateNew}
      onEdit={handleEdit}
      onSelectAssistant={handleSelectAssistant}
    />
  );
};

export default AssistantPage;